<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import type { CvrExportExcelModalProps } from "$lib/types/cvr-export-excel-modal-props";

  let {
    open = false,
    isDownloading = false,
    errorMessage = "",
    onCancel = () => {},
    onDownload = () => {}
  }: CvrExportExcelModalProps = $props();
</script>

{#if open}
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div class="w-full max-w-lg rounded-md border border-border bg-background p-5">
      <h3 class="text-lg font-semibold">Export Excel</h3>
      <p class="mt-2 text-sm text-muted-foreground">
        The export will use the same active filters as the CVR list and include all matching rows (without pagination).
      </p>

      {#if errorMessage.length > 0}
        <p class="mt-3 text-sm text-destructive">{errorMessage}</p>
      {/if}

      <div class="mt-5 flex justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onclick={onCancel}
          disabled={isDownloading}
        >
          Cancel
        </Button>
        <Button
          type="button"
          onclick={onDownload}
          disabled={isDownloading}
        >
          {isDownloading ? "Downloading..." : "Download"}
        </Button>
      </div>
    </div>
  </div>
{/if}
